import React, { useState } from "react";
import { Mail, Send } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", mobile: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/public/contact", form);
      toast.success("Message sent! We'll get back to you soon.");
      setForm({ name: "", email: "", mobile: "", message: "" });
    } catch {
      toast.error("Failed to send. Try again.");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-2 gap-12">
      <div>
        <div className="chip mb-6">Get in touch</div>
        <h1 className="font-display text-5xl font-bold tracking-tight">Let&apos;s talk.</h1>
        <p className="mt-4 text-zinc-600 leading-relaxed max-w-md">
          Have a question, a partnership idea, or feedback? Drop us a line. We typically respond within 24 hours.
        </p>
        <div className="mt-10 space-y-5">
          <div className="flex items-center gap-3 text-sm"><Mail size={18} /> hr@datasprint.in</div>
        </div>
      </div>

      <form onSubmit={submit} data-testid="contact-form" className="card-clean p-8 space-y-4">
        <div>
          <label className="text-xs uppercase tracking-widest text-zinc-500">Name</label>
          <input data-testid="contact-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="mt-1 w-full border border-[var(--line)] rounded-lg px-3 py-2.5 bg-white" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest text-zinc-500">Email</label>
          <input data-testid="contact-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="mt-1 w-full border border-[var(--line)] rounded-lg px-3 py-2.5 bg-white" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest text-zinc-500">Mobile</label>
          <input data-testid="contact-mobile" value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })}
            className="mt-1 w-full border border-[var(--line)] rounded-lg px-3 py-2.5 bg-white" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest text-zinc-500">Message</label>
          <textarea data-testid="contact-message" required rows={4} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
            className="mt-1 w-full border border-[var(--line)] rounded-lg px-3 py-2.5 bg-white resize-none" />
        </div>
        <button data-testid="contact-submit" disabled={busy} className="btn-primary w-full justify-center">
          {busy ? "Sending…" : <>Send Message <Send size={16} /></>}
        </button>
      </form>
    </div>
  );
}
